import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const formContainerVariants = cva("w-full min-w-0", {
  variants: {
    size: {
      sm: "max-w-sm",
      md: "max-w-md",
      lg: "max-w-lg",
      xl: "max-w-xl",
      "2xl": "max-w-2xl",
      full: "max-w-none",
    },
    align: {
      start: "",
      center: "mx-auto",
    },
  },
  defaultVariants: {
    size: "md",
    align: "start",
  },
})

type FormContainerProps = React.ComponentProps<"div"> & VariantProps<typeof formContainerVariants>

function FormContainer({ className, size, align, ...props }: FormContainerProps) {
  return <div className={cn(formContainerVariants({ size, align }), className)} {...props} />
}

export { FormContainer, formContainerVariants }
